import {  Button, IconButton, MenuItem, Select, SelectChangeEvent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import AddIcon from '@mui/icons-material/Add';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { useState } from "react";
import SwitchToggle from "../../components/SwitchToggle";
import React from "react";

const ManageStores = () => {

  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [Status, setStatus] = React.useState('default');
  const handleStatusChange = (event: SelectChangeEvent) => {
    setStatus(event.target.value as string);
  };

  const [rows] = useState([
    {
      id: 1,
      name: "Downtown Store",
      code: "ST001",
      status: "Open",
      address: "123 Main St",
      region: "New York",
      date: "01-Sept-2025"
    },
    {
      id: 2,
      name: "City Mall Store",
      code: "ST002",
      status: "Closed",
      address: "45 Market Road",
      region: "London",
      date: "01-Sept-2025"
    },
    {
      id: 3,
      name: "Central Plaza",
      code: "ST003",
      status: "Open",
      address: "MG Road",
      region: "Delhi",
      date: "01-Sept-2025"
    },
  ]);

  return (
    <>
      <div className="main_title">
        <h1>Store Management</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Store Management
        </p>
      </div>
      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search..."
            />
            <div className=" form">
              <Select
                fullWidth
                value={Status}
                onChange={handleStatusChange} >
                <MenuItem disabled value="default">Select Status</MenuItem>
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Open">Open</MenuItem>
                <MenuItem value="Closed">Closed</MenuItem>
              </Select>
            </div>
          </div>
          <div className="right_s">
            <Button className="btn btn_black"><FileUploadIcon /> Bulk Upload</Button>
            <Button className="btn btn_primary" onClick={() => navigate("/manage-stores/add")}><AddIcon /> Add Store</Button>
          </div>
        </div>

        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow hover>
                <TableCell>Store Code</TableCell>
                <TableCell>Store Name</TableCell>
                <TableCell>Address / Region</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Created Date</TableCell>
                <TableCell>Disable/Enable</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <TableRow hover key={row.id}>
                  <TableCell>
                    <a href="/manage-stores/detail" className="click_action" onClick={() => navigate("/manage-stores/detail")}>
                      <b>{row.code}</b>
                    </a>
                  </TableCell>
                  <TableCell>{row.name}</TableCell>
                  <TableCell>{row.address}, {row.region}</TableCell>
                  <TableCell>
                    <span
                      className={`status_btn dark ${row.status === "Open"
                        ? "c_success"
                        : row.status === "Closed"
                          ? "c_danger"
                          : ""
                        }`}
                    >
                      {row.status}
                    </span>
                  </TableCell>
                  <TableCell>{row.date}</TableCell>
                  <TableCell><SwitchToggle /></TableCell>
                  <TableCell>
                    <div className="table_actions v2">
                      <Button className="btn btn_primary" onClick={() => navigate("/manage-stores/inventory")}>Manage Inventory</Button>
                      <IconButton onClick={() => navigate("/manage-stores/detail")}>
                        <img src="/static/images/eye_icon.svg" alt="" />
                      </IconButton>
                      <IconButton onClick={() => navigate("/manage-stores/add")}>
                        <img src="/static/images/edit2_icon.svg" alt="" />
                      </IconButton>
                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
};

export default ManageStores;
